import React from 'react';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import './HeaderManager.css';

/**
 * HeaderManager - Smart component that shows appropriate header based on screen size
 * Uses CSS media queries to show/hide headers
 * No JavaScript detection needed
 */
const HeaderManager = () => {
    return (
        <div className="header-manager">
            {/* Desktop Header - visible only on desktop */}
            <div className="desktop-header-container">
                <DesktopHeader />
            </div>

            {/* Mobile Header - visible only on mobile */}
            <div className="mobile-header-container">
                <MobileHeader />
            </div>
        </div>
    );
};

export default HeaderManager;